import IncidentList from './IncidentList';
import IncidentShow from './IncidentShow';
import ErrorIcon from '@material-ui/icons/Error';

export default {
  list: IncidentList,
  show: IncidentShow,
  icon: ErrorIcon,
};
